import { render, staticRenderFns } from "./addPrePolicy.vue?vue&type=template&id=261c7497&scoped=true&"
import script from "./addPrePolicy.vue?vue&type=script&lang=js&"
export * from "./addPrePolicy.vue?vue&type=script&lang=js&"
import style0 from "./addPrePolicy.vue?vue&type=style&index=0&id=261c7497&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261c7497",
  null
  
)

export default component.exports